export default function (provider, prevRoute) {
  let originHost = window.location.origin;
  let originApiHost = originHost;
  if (originHost.endsWith("3000")) {
    originApiHost = originHost.replace("3000", "8080");
  }
  return `${originApiHost}/oauth2/authorization/${provider}?redirect_uri=${originHost + prevRoute}&mode=login`;
}
